import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Text } from 'foundations-components/components/Text';
import { getAppShortlink } from 'marketplace-ui-assets-core/utils/urls';
import { useLocation } from 'react-router-dom';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function GenericError() {
  const {
    pathname
  } = useLocation();
  return /*#__PURE__*/_jsx(ErrorMessage, {
    title: unescapedText('marketplace-assets-ui.error.default.title'),
    children: /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      direction: "column",
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.error.default.body"
        })
      }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "marketplace-assets-ui.error.default.cta_jsx",
        options: {
          onRefresh: () => window.location.reload(),
          loginUrl: getAppShortlink({
            pathname
          })
        },
        elements: {
          Link
        }
      })]
    })
  });
}